export default __webpack_public_path__ + "static/media/big-screen.cb8adb52.png";